import { render, staticRenderFns } from "./hubTable.vue?vue&type=template&id=2d8e96a6"
import script from "./hubTable.vue?vue&type=script&lang=js"
export * from "./hubTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports